module.exports = __webpack_public_path__ + "static/media/model-mission-10.bf09ef72.png";